import { useState } from "react";
import { SongtradrGroupLogos } from "@songtradr-sso/shared/frontend";
import { Heading } from "@songtradr/design-language";
import { AuthButtons } from "../../components/auth-buttons/AuthButtons";
import { EmailPasswordSignIn } from "../../components/email-password/sign-in/EmailPasswordSignIn";
import { PageContainer } from "../../components/page-container/PageContainer";
import { useAuthContext } from "../../layouts/App.Parts";
import { getEmailMode } from "./SignIn.Parts";

export const SignIn = () => {
  const { workspace, orgName, loginMethods = [], assets } = useAuthContext();

  const [emailMode, setEmailMode] = useState(
    getEmailMode(workspace, loginMethods),
  );
  const hasBackButton = emailMode && (!workspace || loginMethods.length > 1);

  const renderLogo = () => {
    if (!workspace) return <SongtradrGroupLogos />;
    if (assets?.logo) return <img src={assets.logo} alt={`${orgName} Logo`} />;
    return <Heading>{orgName}</Heading>;
  };

  return (
    <PageContainer
      header={renderLogo()}
      background={assets?.background}
      backButton={hasBackButton ? () => setEmailMode(false) : false}
      changeWorkspaceButton
    >
      {emailMode ? (
        <EmailPasswordSignIn />
      ) : (
        <AuthButtons onEmailButtonClick={() => setEmailMode(true)} />
      )}
    </PageContainer>
  );
};
